<template>
  <div class="event-outer-box">
    <div v-for="(event, eventIndex) in taskData" :key="event.id" :class="['event-item', expandedEventId == event.id ? 'open' : '', selectedEventId == event.id ? 'active' : '']">
      <div class="event-name" @click="selectEvent(event,1)">
        <div class="name">{{ event.name }}</div>
        <div class="icon" v-if="(eventIndex+1)!=taskData.length&&chapterData && chapterData.length" @click.stop="toggleChapter(event.id)"></div>
        <div class="chapter-content" v-if="chapterData && chapterData.length && expandedEventId == event.id" @mouseleave="expandedEventId = null">
          <div class="chapter-scroll">
            <div v-for="(chapter) in chapterData" :key="chapter.id" :class="['chapter-item', (selectedChapterId == chapter.id) ? 'active' : '']" @click.stop="selectChapter(chapter)">
              <span class="chapter-num" v-if="chapter.chapter_num">{{ chapter.chapter_num }}</span>
              <span class="chapter-name">{{ chapter.name }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="event-child" v-if="event.children && event.children.length">
        <div v-for="(child, childIndex) in event.children" :key="child.id" :class="['child-item', selectedTaskId == child.id ? 'active' : '']" @click="selectTask(event, child)">
          <div :class="['child-icon', `task-${eventIndex+1}-${childIndex+1}`]"></div>
          <div class="child-name">{{ child.name.split('：')[1] }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import axios from 'axios';
import utils from '../../assets/js/utils';
export default {
  name: "EventBar",
  data () {
    return {
      utils,
      school_code: localStorage.getItem("schoolCode"),
      selectedEventId: null,
      selectedTaskId: null,
      selectedChapterId: null,
      expandedEventId: null,
    };
  },
  computed: {
    ...mapState({
      chapterData: (state) => state.train.chapterData,
      taskData: (state) => state.train.taskData
    }),
  },

  async mounted () {
    this.listenRequest()

    // this.routerPush();
    const params = this.$route.query;

    // 先加载任务和章节数据
    await this.methodTaskData({ course_id: params.course_id, activity_id: params.activity_id, is_progress: 1 });
    await this.methodChapterData({ course_id: params.course_id });

    // 如果没有选中的章节，默认选第一个
    if (!this.selectedChapterId && this.chapterData.length) {
      this.selectedChapterId = await params.chapter_id || this.chapterData[0].id;
    }

    // 选中正确的环节和任务
    this.$watch('$route', this.setActiveByRoute, { immediate: true });
  },

  methods: {
    ...mapActions(['methodChapterData', 'methodTaskData', 'methodActivityDetail']),
    // 监听所有提交任务接口,更新任务进度/得分情况
    listenRequest () {
      const targetAPIs = [
        /\/api\/center\/train\/course\/resource\/.+\/play/, // /api/center/train/course/resource/{resource}/play
        '/api/center/train/learn/log/add',
        '/api/center/train/hall/log/add',
        '/api/center/train/study/hub/log/add',
        '/api/center/train/question/log',
        '/api/center/train/work/t005',
        '/api/center/train/work/t006',
        '/api/center/train/work/t007',
        '/api/center/train/work/t008',
      ];

      axios.interceptors.response.use(
        (response) => {
          if (targetAPIs.some((api) => {
            if (typeof api === 'string') {
              return response.config.url.includes(api);
            } else if (api instanceof RegExp) {
              return api.test(response.config.url);
            }
            return false;
          })) {
            this.handleNextStep(response);
          }
          return response;
        }
      );
    },
    async handleNextStep (result) {
      if (result.data.code === '0000') {
        // 更新任务进度/得分情况
        const params = this.$route.query;
        await this.methodActivityDetail({ id: params.activity_id });
        await this.methodTaskData({
          course_id: params.course_id,
          activity_id: params.activity_id,
          is_progress: 1,
        });
      }
    },
    // 避免刷新后 chapter_id 被覆盖
    routerPush () {
      if (this.currentChapterId && this.$route.query.chapter_id !== this.currentChapterId) {
        this.$router.replace({
          path: this.$route.path,
          query: { ...this.$route.query, chapter_id: this.currentChapterId }
        });
      }
    },

    setActiveByRoute () {
      const { path, query } = this.$route;
      this.selectedChapterId = query.chapter_id || this.chapterData[0] && this.chapterData[0].id;
      for (let i = 0; i < this.taskData.length; i++) {
        let item = this.taskData[i]
        if (item.children && item.children.length > 1) {
          for (let j = 0; j < item.children.length; j++) {
            let sItem = item.children[j]
            if (path.indexOf(sItem.path) > -1) {
              this.selectEvent(item);
              this.selectTask(item, sItem);
            }
          }
        } else {
          for (let j = 0; j < item.children.length; j++) {
            let sItem = item.children[j]
            if (path.indexOf(sItem.path) > -1) {
              if (path.indexOf(sItem.path) > -1) {
                this.selectEvent(item);
                this.selectTask(item, sItem);
              }
            }
          }
        }
      }

      // 确保路由同步更新
      this.routerPush();
    },

    // 切换章节菜单显示/隐藏
    toggleChapter (id) {
      this.expandedEventId = this.expandedEventId == id ? null : id;
    },

    // 选择事件（event）
    selectEvent (event, level_1) {
      if (this.selectedEventId !== event.id) {
        this.selectedEventId = event.id;
        this.expandedEventId = null;
        this.routerPush();
      }
      this.selectedEventId = event.id
      // 点击了环节,跳转到第一个任务页面
      if (level_1) {
        this.selectedTaskId = event.children[0].id
        this.$router.replace({
          path: event.children[0].path,
          query: { ...this.$route.query, chapter_id: this.selectedChapterId }
        }).catch(err => { err });
      }
    },

    // 选择任务（task）
    selectTask (event, task) {
      this.selectedEventId = event.id;
      this.selectedTaskId = task.id;
      this.$router.replace({
        path: task.path,
        query: { ...this.$route.query, chapter_id: this.selectedChapterId }
      }).catch(err => { err });
    },

    // 选择章节
    selectChapter (chapter) {
      if (!chapter) return;
      this.selectedChapterId = chapter.id;
      this.routerPush();

      // 查找当前展开的 event，并选中
      const relatedEvent = this.taskData.find(event => event.id == this.expandedEventId);
      if (relatedEvent) {
        if (relatedEvent.id !== this.selectedEventId) {
          this.selectEvent(relatedEvent);
        }
        if (relatedEvent.children && relatedEvent.children.length) {
          this.selectTask(relatedEvent, relatedEvent.children[0]);
        }
      }
      this.expandedEventId = null;
    },
  }
};
</script>
<style lang="less" scoped>
.event-outer-box {
    width: 200px;
    height: 700px;
    background: url('../../assets/image/student/common/bar-img.png') no-repeat
        center/cover;
    padding: 14px 10px 0 0;
    z-index: 99;
    .event-item {
        position: relative;
        &:not(:last-child) {
            margin-bottom: 6px;
        }
        .event-name {
            position: relative;
            cursor: pointer;
            .name {
                padding-left: 19px;
                width: 100%;
                height: 46px;
                line-height: 46px;
                font-weight: bold;
                font-size: 15px;
                color: #373536;
                border-radius: 0px 23px 23px 0px;
                position: relative;
            }
            .icon {
                content: '';
                display: inline-block;
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                right: 14px;
                width: 14px;
                height: 14px;
                background: url('../../assets/image/student/common/bar-item.png')
                    no-repeat center/cover;
            }
            &:hover {
                .name {
                    background: #ffffff;
                    color: #a82822;
                }
            }
            .chapter-content {
                position: absolute;
                top: -14px;
                left: 100%;
                width: 386px;
                &::before {
                    content: '';
                    display: inline-block;
                    width: 0;
                    height: 0;
                    border-top: 6px solid transparent;
                    border-bottom: 6px solid transparent;
                    border-right: 6px solid #ffffff; /* 右边的边框颜色决定三角形颜色 */
                    position: absolute;
                    right: 100%;
                    top: 30px;
                }
                .chapter-scroll {
                    width: 100%;
                    height: 100%;
                    max-height: 76vh;
                    overflow-y: auto;
                    padding: 10px 3px;
                    background: #ffffff;
                    box-shadow: 0px 0px 6px 0px rgba(133, 135, 137, 0.26);
                    border: 1px solid #ebedef;
                    .chapter-item {
                        display: flex;
                        padding: 7px 30px 7px 14px;
                        border: 1px solid transparent;
                        font-size: 14px;
                        color: #373536;
                        position: relative;
                        &:not(:last-child) {
                            margin-bottom: 2px;
                        }
                        &::before {
                            content: '';
                            display: inline-block;
                            width: 4px;
                            height: 4px;
                            background: #dde1e6;
                            margin-right: 10px;
                            flex-shrink: 0;
                            margin-top: 9px;
                        }

                        .chapter-num {
                            margin-right: 8px;
                            white-space: nowrap;
                        }

                        &:hover {
                            background: #f8f8f8;
                            border: 1px solid #ebedef;
                        }
                        &.active {
                            border: 1px solid transparent;
                            background: #fff3f2;
                            color: #a82822;
                            &::before {
                                background: #a82822;
                            }
                            &::after {
                                opacity: 1;
                            }
                        }
                        &::after {
                            opacity: 0;
                            content: '当 前';
                            display: inline-block;
                            width: 16px;
                            background: linear-gradient(
                                90deg,
                                rgba(192, 64, 58, 0.16) 3%,
                                rgba(187, 28, 21, 0.16) 100%
                            );
                            text-align: center;
                            line-height: 16px;
                            font-size: 10px;
                            color: #a82822;
                            writing-mode: vertical-lr;
                            position: absolute;
                            top: 50%;
                            transform: translateY(-50%);
                            width: 16px;
                            height: calc(100% - 2px);
                            right: 2px;
                            font-weight: bold;
                        }
                    }
                }
            }
        }
        &.active {
            .event-name {
                .name {
                    color: #ffffff;
                    background: linear-gradient(
                        90deg,
                        #c0403a 3%,
                        #bb1c15 100%
                    );
                }
                .icon {
                    background: url('../../assets/image/student/common/bar-item-active.png')
                        no-repeat center/cover;
                }
            }
        }
        &.open {
            .event-name {
                .icon {
                    background: url('../../assets/image/student/common/bar-item-open.png')
                        no-repeat center/cover;
                }
            }
        }
        .event-child {
            padding-top: 6px;
            .child-item {
                cursor: pointer;
                margin-left: 20px;
                display: flex;
                align-items: center;
                font-size: 14px;
                color: #5b534e;
                height: 32px;
                line-height: 32px;
                border-radius: 16px;
                padding: 0 20px 0 15px;
                width: max-content;
                &:not(:last-child) {
                    margin-bottom: 2px;
                }
                &.active {
                    background: #ffffff;
                    color: #a82822;
                }
                &:hover {
                    background: #ffffff;
                }
                &:hover,
                &.active {
                    .child-icon {
                        &.task-1-1 {
                            background-image: url('../../assets/image/student/common/task-1-1-active.png');
                        }
                        &.task-2-1 {
                            background-image: url('../../assets/image/student/common/task-2-1-active.png');
                        }
                        &.task-3-1 {
                            background-image: url('../../assets/image/student/common/task-3-1-active.png');
                        }

                        &.task-4-1 {
                            background-image: url('../../assets/image/student/common/task-4-1-active.png');
                        }
                        &.task-4-2 {
                            background-image: url('../../assets/image/student/common/task-4-2-active.png');
                        }
                        &.task-4-3 {
                            background-image: url('../../assets/image/student/common/task-4-3-active.png');
                        }
                        &.task-4-4 {
                            background-image: url('../../assets/image/student/common/task-4-4-active.png');
                        }
                    }
                }
                .child-icon {
                    width: 12px;
                    height: 12px;
                    margin-right: 10px;
                    background-position: center;
                    background-size: cover;
                    background-repeat: no-repeat;

                    &.task-1-1 {
                        background-image: url('../../assets/image/student/common/task-1-1.png');
                    }
                    &.task-2-1 {
                        background-image: url('../../assets/image/student/common/task-2-1.png');
                    }
                    &.task-3-1 {
                        background-image: url('../../assets/image/student/common/task-3-1.png');
                    }

                    &.task-4-1 {
                        background-image: url('../../assets/image/student/common/task-4-1.png');
                    }
                    &.task-4-2 {
                        background-image: url('../../assets/image/student/common/task-4-2.png');
                    }
                    &.task-4-3 {
                        background-image: url('../../assets/image/student/common/task-4-3.png');
                    }
                    &.task-4-4 {
                        background-image: url('../../assets/image/student/common/task-4-4.png');
                    }
                }
            }
        }
    }
}
</style>